/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCheckRecipient} from '../api'

export const useMutationCreateCheckRecipient = createReactQueryMutationHook('createCheckRecipient', createCheckRecipient)
